import { Typography } from '@mui/material';

import { Card } from 'src/components';
import { Flex } from 'src/components/Flex';

const TableKey = () => {
    return (
        <Card gap="36px">
            <Flex flexDirection="row" gap="19px">
                <Flex flex={1}>
                    <Typography fontSize="18px" fontWeight="500" lineHeight="20px" color="#F39E4E">
                        <strong>KEY:</strong>
                    </Typography>
                </Flex>
                <Flex flex={2}>
                    <Typography fontSize="14px" fontWeight="500" lineHeight="20px" color="#1d1d1b">
                        <strong>Payment Received (DD):</strong> Direct Debit
                    </Typography>
                </Flex>
                <Flex flex={2}>
                    <Typography fontSize="14px" fontWeight="500" lineHeight="20px" color="#1d1d1b">
                        <strong>Payment Received (CP):</strong> Card Payments
                    </Typography>
                </Flex>
                <Flex flex={2}>
                    <Typography fontSize="14px" fontWeight="500" lineHeight="20px" color="#1d1d1b">
                        <strong>Payment Received (BT):</strong> Bank Transfer
                    </Typography>
                </Flex>
            </Flex>
        </Card>
    );
};

export default TableKey;
